import { Button } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function ColumnsButton() {
  const Icon = () => {
    return (
      <svg
        width="12"
        height="10"
        viewBox="0 0 12 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.333344 8.12818V1.87182C0.333344 1.53934 0.451082 1.25537 0.68656 1.0199C0.922027 0.784422 1.206 0.666683 1.53848 0.666683H10.4513C10.7837 0.666683 11.0677 0.784422 11.3032 1.0199C11.5386 1.25537 11.6564 1.53934 11.6564 1.87182V8.12818C11.6564 8.46066 11.5386 8.74463 11.3032 8.9801C11.0677 9.21558 10.7837 9.33332 10.4513 9.33332H1.53848C1.206 9.33332 0.922027 9.21558 0.68656 8.9801C0.451082 8.74463 0.333344 8.46066 0.333344 8.12818ZM1.53848 8.33333H3.56923C3.62052 8.33333 3.66753 8.31197 3.71026 8.26923C3.753 8.22649 3.77438 8.17947 3.77438 8.12818V1.87182C3.77438 1.82053 3.753 1.77351 3.71026 1.73077C3.66753 1.68803 3.62052 1.66667 3.56923 1.66667H1.53848C1.48719 1.66667 1.44017 1.68803 1.39743 1.73077C1.35469 1.77351 1.33333 1.82053 1.33333 1.87182V8.12818C1.33333 8.17947 1.35469 8.22649 1.39743 8.26923C1.44017 8.31197 1.48719 8.33333 1.53848 8.33333ZM4.97949 8.33333H7.01024C7.06153 8.33333 7.10854 8.31197 7.15128 8.26923C7.19402 8.22649 7.21539 8.17947 7.21539 8.12818V1.87182C7.21539 1.82053 7.19402 1.77351 7.15128 1.73077C7.10854 1.68803 7.06153 1.66667 7.01024 1.66667H4.97949C4.9282 1.66667 4.88119 1.68803 4.83844 1.73077C4.79571 1.77351 4.77434 1.82053 4.77434 1.87182V8.12818C4.77434 8.17947 4.79571 8.22649 4.83844 8.26923C4.88119 8.31197 4.9282 8.33333 4.97949 8.33333ZM8.42051 8.33333H10.4513C10.5025 8.33333 10.5496 8.31197 10.5923 8.26923C10.635 8.22649 10.6564 8.17947 10.6564 8.12818V1.87182C10.6564 1.82053 10.635 1.77351 10.5923 1.73077C10.5496 1.68803 10.5025 1.66667 10.4513 1.66667H8.42051C8.36922 1.66667 8.32221 1.68803 8.27948 1.73077C8.23673 1.77351 8.21536 1.82053 8.21536 1.87182V8.12818C8.21536 8.17947 8.23673 8.22649 8.27948 8.26923C8.32221 8.31197 8.36922 8.33333 8.42051 8.33333Z"
          fill="#6C6B6E"
        />
      </svg>
    );
  };

  return (
    <Button
      color={"#6C6B6E"}
      backgroundColor={"#FFFFFF"}
      border="1px solid #D4D4D4"
      variant="outline"
      leftIcon={<Icon />}
      size="sm"
    >
      Columns
    </Button>
  );
}
